export default {
  common: {
    language: '言語',
    logoAlt: 'Zhongze STEAM',
    cancel: 'キャンセル',
  },
  chatService: {
    chatNow: {
      label: '今すぐチャット',
    },
    emailGate: {
      title: 'メールアドレスが必要です',
      desc: 'チャットを続けるにはメールアドレスを入力してください。',
      successMessage: 'メールアドレスを送信しました。続けてチャットできます。',
    },
  },
  nav: {
    home: 'ホーム',
    products: '製品',
    software: 'ソフトウェア',
    eduServices: '教育サービス',
    support: 'サービス＆サポート',
    cooperation: '教育協力',
    about: '私たちについて',

    // Sub-menus & Mega Menu
    learningPlatform: 'Zhongze Education 学習プラットフォーム',
    cloudPlatform: 'Zhongze Education クラウドプラットフォーム',
    laserSoftware: 'レーザー装置専用ソフトウェア',
    makerK12: 'メーカー教育 - 小中学校',
    archVocational: '建築模型 - 職業高校',
    cultHigherVoc: '文化・クリエイティブデザイン - 高等職業',
    artsUni: 'アート＆クラフト - 大学',
    afterSales: 'アフターサービス',
    faq: 'よくある質問',
    download: 'ダウンロードセンター',
    companyIntro: '会社概要',
    news: 'ニュース',
    contact: 'お問い合わせ',
    device: '機器',
    kits: 'キット',
    softwareService: 'ソフトウェアサービス',
    accessories: 'アクセサリー',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'キットシステム',
    kitsAccessories: 'キットアクセサリー',
    courses: 'コース',
  },
  aboutPage: {
    seoTitle: '私たちについて - Zhongze STEAM',
    banner: {
      title: '私たちについて',
    },
    about: {
      title: '私たちについて',
      body: 'Zhongze Educationは2015年に設立され、香港聯通国際との緊密な連携を基盤に、欧米のSTEAMカリキュラムを参考にしながら、国内の子どもに適したメイカー教育体系を自主開発してきました。社会的な学びと実践を通じて、子どもたちが限界を越え、素晴らしい創造を生み出せるよう支援します。私たちは「STEAM教育＋メイカースペース」を中核に、「未来の創造者を育てる」という使命のもと、3〜16歳の子ども・青少年の科学技術創造力教育に注力しています。メイカースペースを開設し、教育向けプロダクトとカリキュラムを自社開発。学習用デザインソフト、レーザー彫刻、プログラミングなどの領域を軸に、独自の教育コンテンツ開発エコシステムとプロダクトの循環を構築しました。子どもたちが実際のプロジェクトの中で、未来に適応するための中核能力を身につけられることを目指しています。私たちのビジョンは、国際的なメイカー教育の推進者となること。提供するのはカリキュラムや環境だけではなく、新しい学びのスタイルそのものです。すべての子どもが未来のイノベーターであると信じ、科学者のように探究し、エンジニアのように手を動かし、デザイナーのように創造し、メイカーのように学び、つくる力を育みます。探索の中で自分を見つけ、実践の中で未来を切り拓く──それが私たちの願いです。',
    },
    intro: {
      title: 'なぜ私たちを選ぶのか？',
      desc: '国際的なメイカー教育の推進者として、カリキュラムとメイカー環境を提供するだけでなく、新しい学び方そのものを提案します。すべての子どもが未来のイノベーターであると信じ、探索の中で自分を見つけ、実践の中で未来を切り拓けるよう支援します。',
      features: {
        projectLearning:
          'プロジェクト型学習：実際のプロジェクトを通じて、未来に適応するための中核能力を身につけます。',
        interactiveExperiments:
          '体験型実験：体験を通して基礎的な科学原理を理解するだけでなく、問題解決力・創造力・チームワークも育みます。',
      },
    },
    images: {
      aboutAlt: 'Zhongze STEAMについて',
      featureIcon1Alt: 'プロジェクト型学習のアイコン',
      featureIcon2Alt: '体験型実験のアイコン',
      introAlt: 'なぜ私たちを選ぶのか',
    },
  },
  newsPage: {
    banner: {
      title: 'ニュース',
    },
    tabs: [
      { id: 'all', name: 'すべて' },
      { id: 'company', name: '会社ニュース' },
      { id: 'exhibition', name: '展示会ニュース' },
      { id: 'industry', name: '業界動向' },
    ],
    items: [
      {
        title:
          'Henghaoレーザー、BETT UK 2025で注目：レーザー技術で教育イノベーションを加速',
      },
      {
        title:
          'K12教育イノベーションの核：CO2レーザーカッターがSTEAM授業をどう推進するか',
      },
      {
        title:
          'HenghaoレーザーのユーザーがLight 530とともに didacta Italia 2025で活躍',
      },
      { title: 'Zhongze Education、新しいスマート教育ソリューションを発表' },
      { title: '未来の教育動向：AIとメイカー教育の深い融合' },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'ニュース',
    },
    tabs: [
      { id: 'all', name: 'すべて' },
      { id: 'company', name: '会社ニュース' },
      { id: 'exhibition', name: '展示会ニュース' },
      { id: 'industry', name: '業界動向' },
    ],
    items: [
      {
        title:
          'Zhongze Technology、新世代の教育用ロボットキットを発表—STEM教育の新潮流をリード',
      },
      {
        title: 'AIが学校へ：プログラミング教育で生徒の論理的思考力を高める方法',
      },
      {
        title:
          '2023年度全国青少年ロボット大会が閉幕、Zhongze支援チームが好成績を獲得',
      },
      {
        title:
          '未来の教育を探る：デジタル変革の潮流におけるスマート教室構築プラン',
      },
      {
        title:
          'Zhongze Technology、複数の大学と戦略提携—AI共同研究室を共同設立',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'メイカー教育',
        desc: '実験と探究の場を提供し、生徒の総合的な成長を促進します',
      },
      item2: {
        title: '知の扉を開く',
        desc: 'レーザー機器の活用からキット学習まで、さまざまな学習ニーズを総合的に満たします。',
      },
      item3: {
        title: 'キット＆コース',
        desc: 'AI・ISTEAM・メイカー教育の授業効率化に最適',
      },
    },
    resources: {
      title: '豊富なSTEM学習リソース',
      tabs: {
        laser: {
          name: 'レーザーカッター',
          title: 'レーザー機器',
          desc1: 'スマート卓上型レーザー切断・彫刻機',
          desc2: '高精度カット│スマートで簡単操作│高効率加工│安全・環境配慮',
        },
        software: {
          name: 'ソフトウェア',
          title: '教育向けソフトウェア',
          desc1: '多角的なオールインワンソフト',
          desc2:
            'クラウドプラットフォーム | 学習プラットフォーム | Light Maker',
        },
        ai: {
          name: 'AIスマート授業支援',
          title: 'スマート授業支援',
          desc1: 'リアルタイム監視と機器アラート',
          desc2: 'AIティーチングアシスタント | ビジュアルダッシュボード',
        },
        kits: {
          name: 'キット＆コース',
          title: '充実したカリキュラムキット',
          desc1: 'PBLプロジェクト型学習',
          desc2: '教材セット | ハンズオン実践',
        },
      },
    },
    different: {
      title: '私たちの強み',
      items: {
        solution: {
          title: '教育AIソリューション',
          desc: '授業効果と学習体験を向上',
        },
        course: {
          title: '創造的思考カリキュラム',
          desc: '3〜16歳の子どもに最適',
        },
        product: {
          title: 'メイカー教育プロダクト',
          desc: 'ワンクリックでレーザー制作',
        },
        space: { title: 'メイカー探究スペース', desc: '革新性と実用性を両立' },
      },
    },
    creative: {
      title: 'アイデアで駆動し、ものづくりの未来へ',
      machineDesc: 'スマート卓上型レーザー切断＆彫刻機',
      lightBlue530Desc: 'スマートブルーレーザー切断＆彫刻機',
      markM20Desc: '高精度レーザーマーキング機',
      light640Desc: 'プロ向け卓上レーザー切断＆彫刻機',
    },
    innovation: {
      title: 'イノベーション学習をどう促進する？',
      desc: 'Zhongze STEAMはレーザーカッターなど高品質なメイカー教育プロダクトの開発に注力しています。これらの製品は、科学・技術・工学・芸術・数学の領域での実践学習を力強く支援します。',
      items: {
        steam: 'STEAM',
        coding: 'プログラミング',
        light530: 'Light 530の活用',
        robotics: 'ロボティクス',
      },
    },
    bottomBanner: {
      title: 'AI教育を現場へ',
      subtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
      desc: 'レーザーのカスタマイズ製品と技術サービスに注力し、学校・企業の「AI＋教育」融合を支援します',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'レーザー装置専用ソフトウェア  Light Maker',
      bannerDesc:
        'プロ向けレーザー装置ソフト。シンプルで高効率、切断と彫刻の体験に特化。',
      bannerImageAlt: 'Light Maker 画面',
      creationTitle: '創作をもっと簡単に',
      features: {
        proDesignTool: 'プロ仕様のデザインツール',
        highPrecisionParams: '高精度パラメータ設定',
        multiDeviceControl: '複数機器の管理・制御',
        assetLibrary: '強力な素材ライブラリ管理',
      },
      intro: {
        imageAlt: '機能紹介',
        items: {
          item1: {
            title: 'パワフルで使いやすいデザインシステム',
            desc: '強力な制作ソフトで、JPG、DXF、AI、DST、PNG、BMP、TIF、SVG形式の高品質データに対応します。',
          },
          item2: {
            title: 'プロフェッショナル',
            desc: '高度な描画機能であらゆる制作ニーズに対応。複雑なデザインでもシンプルなカットでも、スムーズにこなせます。',
          },
        },
      },
      downloadTitle: 'ソフトウェアのダウンロード',
      downloadButton: 'ダウンロードして試す',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Zhongze Education 学習プラットフォーム',
      bannerDescLine1:
        'Zhongze Education 学習プラットフォームは、学習者と教師に向けた包括的な教育ソフトウェアソリューションを提供するために設計された、革新的なオンライン学習ツールです。',
      bannerDescLine2:
        'モバイルでもPCでも、ユーザーはプラットフォームに簡単にアクセスして利用できます。',
      bannerImageAlt: 'Zhongze Education 学習プラットフォーム画面',
      exploreTitle: '無限の可能性を探究し、輝く未来を創る',
      exploreTabs: [
        { name: '作成' },
        { name: 'はじめに' },
        { name: 'モデリング学習' },
        { name: 'ワンクリック作成' },
        { name: 'AI画像生成' },
      ],
      tabContentAlt: '機能紹介',
      introTitle: '革新的な学習プラットフォーム',
      introItems: [
        {
          title: '効率的な学習の新体験',
          desc: 'Zhongze Education 学習プラットフォームは、コース学習・グラフィックデザイン・レーザー切断機能をワンストップで統合。カード型UIはシンプルで直感的、操作もスムーズです。創造的なデザインから実物制作までをシームレスにつなぎ、すぐに使いこなせます。',
        },
        {
          title: 'スマートで便利、初心者も安心',
          desc: '豊富な内蔵素材とスマートなパラメータプリセットにより、ワンクリックで制作でき、初心者でもすぐに開始可能。モバイル側の丁寧なガイドチュートリアルで迷わず学べます。さらにクラウドで機器状態をリアルタイム監視し、授業の安全をプロセス全体で守ります。',
        },
      ],
      introImageAlt: '革新的な学習プラットフォーム',
      galleryAlt: 'プラットフォームの紹介',
      downloadTitle: 'ソフトウェアのダウンロード',
      downloadApps: [
        { name: 'Zhongze Education アプリ' },
        { name: 'Zhongze デザインソフト（PC）' },
      ],
      downloadButtonText: 'ダウンロードして試す',
    },
    cloudPlatform: {
      bannerTitle: 'Zhongze Education クラウドプラットフォーム',
      bannerDesc:
        '課題の配布・回収、機器監視、修理依頼、パラメータ設定に対応するワンストップの教育管理ツールで、教師・学習者・学校の効率的な運用を支援します。',
      bannerImageAlt: 'Zhongze Education クラウドプラットフォーム画面',
      exploreTitle: '授業運用をシンプルに',
      exploreTabs: [
        { name: '作成' },
        { name: 'はじめに' },
        { name: '応用学習' },
      ],
      tabContentAlt: '機能紹介',
      introTitle: '教育の効率を向上',
      introItems: [
        {
          title: '簡単操作',
          desc: 'ワンクリック作成：内蔵素材とパラメータ設定で、制作フローを簡素化。機器監視：機器状態をリアルタイムで把握し、授業活動が円滑に進むよう支援します。',
        },
        {
          title: '一元管理',
          desc: '機器連携：メイカー教室内の他機器とも連携し、ワンクリック管理で運用効率を高めます。',
        },
        {
          title: 'リアルタイム監視',
          desc: '機器状態：稼働状況をリアルタイムで把握し、故障時は迅速に修理依頼。メンテナンス：稼働時間や使用頻度に基づき定期的に保守を通知し、機器寿命を延ばして加工品質を向上させます。',
        },
      ],
      introImageAlt: '革新的な学習プラットフォーム',
      galleryTitle: 'AI教育を現場へ',
      galleryDesc: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
    },
  },
  eduServices: {
    banner: {
      title: 'AI＋教育',
      desc: 'Zhongze Educationのデジタルインテリジェンス授業ソリューションは、国のイノベーション人材育成を支援し、教育の発展と学習者のニーズを軸に、K-12向けに全学年対応のAI教育プランを提供します。',
      imageAlt: '教育ソリューションバナー',
    },
    recommended: {
      title: 'おすすめ製品',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'オールラウンドな学習空間を構築',
      tabs: {
        'teaching-assist': 'スマート授業支援',
        'process-optimize': '授業フロー最適化',
        'device-manage': '機器管理',
      },
      tabContents: {
        'teaching-assist': {
          title: 'スマート授業支援',
          features: [
            '·リアルタイム監視と機器・備品管理',
            '·AIスマート教学アシスタント',
            '·ビジュアルダッシュボード',
          ],
        },
        'process-optimize': {
          title: '授業フロー最適化',
          features: [
            '·オンライン課題の配布と採点',
            '·遠隔集中管理でコースのクラウド資源を運用',
          ],
        },
        'device-manage': {
          title: '機器管理',
          features: ['·教育機器のリアルタイム監視', '·遠隔修理依頼'],
        },
      },
      categories: [
        {
          title: 'オンライン課題の配布と採点',
          description: 'スマートな課題管理システムで授業効率を向上',
        },
        {
          title: '遠隔修理依頼',
          description: '便利な遠隔メンテナンス／修理依頼サービス',
        },
        {
          title: '遠隔集中管理で授業運用を簡素化',
          description: '統合リモート管理プラットフォームで授業フローを最適化',
        },
        {
          title: 'コースのクラウド資源',
          description: '豊富なクラウド教材と授業素材',
        },
        {
          title: '教育機器のリアルタイム監視',
          description: '機器状態をリアルタイムで把握し、授業を円滑に進行',
        },
        {
          title: 'AIスマート教学アシスタント',
          description: 'AI駆動のスマート授業支援システム',
        },
      ],
      solutionCards: [
        { title: 'メイカー教育のデジタルインテリジェンス・ソリューション' },
        { title: '小中学校向けスマート教室ソリューション' },
        { title: '中等・高等職業向けスキル育成ソリューション' },
        { title: '大学向けAI教室ソリューション' },
      ],
    },
    solutions: {
      title: 'ワンストップ教育ソリューション',
      items: [
        {
          title: '機器',
          description:
            'AIが教育を支える時代において、Henghaoのレーザーカッターはスマートクラウド基盤を通じてZhongze Educationのレーザー教学クラウドと深く連携します。教師は遠隔で機器を管理し、課題を配布し、学習進捗を追跡可能。この統合により授業効率が高まり、学習者にはよりパーソナライズされた学習体験を提供します。',
          buttonText: '詳細を見る →',
        },
        {
          title: 'ソフトウェア',
          description:
            'Zhongze EducationプラットフォームはAI技術を統合し、パーソナライズ学習、スマートツール、インタラクティブ体験、クラウド資源を提供します。コース／課題管理、機器監視とアラート、データ分析にも対応。学習プラットフォーム（APP/PC）とLight Makerツールと組み合わせることで、授業を多面的に支援し、リソースを最適化して教育イノベーションを推進します。',
          buttonText: '詳細を見る →',
        },
        {
          title: 'コース',
          description:
            'Zhongze Educationのメイカー切断カリキュラムは、青少年向けに設計された体系的・モジュール型プログラムです。興味と可能性を引き出し、テクノロジー知識、創造的思考、プロジェクト実践、科学実験をカバー。未来のイノベーション人材育成を支援し、社会の発展に貢献します。',
          buttonText: '詳細を見る →',
        },
      ],
    },
    managementPlatform: {
      title: 'Zhongze Education スマート授業管理プラットフォーム',
      desc: 'パーソナライズ学習パス、スマート授業ツール、インタラクティブ学習体験、クラウドリソースライブラリを提供。コース管理、学習進捗追跡、オンライン課題、教育機器のリアルタイム監視とアラート、データ分析などに対応します。AI技術の統合により授業効果を高め、教育リソースの最適配分を実現し、学習者・教師・学校・教育機関を包括的に支援します。',
      items: [
        {
          title: 'メイカー教育のデジタルインテリジェンス・ソリューション',
          alt: 'メイカー教育のデジタルインテリジェンス・ソリューション',
        },
        {
          title: '小中学校向けスマート教室ソリューション',
          alt: '小中学校向けスマート教室ソリューション',
        },
        {
          title: '中等・高等職業向けスキル育成ソリューション',
          alt: '中等・高等職業向けスキル育成ソリューション',
        },
        {
          title: '大学向けAI教室ソリューション',
          alt: '大学向けAI教室ソリューション',
        },
      ],
      action: {
        text: '専用ソリューションを入手',
        alt: 'お問い合わせアイコン',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'メーカー教育—小中学校',
    },
    intro: {
      title: '学校教育におけるレーザーカッター',
      desc: '学校でレーザーカッターを使えば、アイデアから完成品までを安全・非接触・デジタルに実現できます。子どもたちの発想を手軽に形にします。',
      imageAlt: '建築模型制作におけるレーザーカッター',
    },
    scenesFeatured: {
      title: '最先端の教育ツールで学び方を変える',
      desc: '業界をリードする技術を学習者に提供し、創造力・批判的思考・技術スキルを高めます。',
    },
    scenes: {
      items: [
        {
          title: 'すべての学習者にレーザー創作の場を',
          desc: '学習者の参加力を育て、強力なツールを使って教室で創造的思考を伸ばします。',
        },
        {
          title: '電子・プログラミングキット',
          desc: 'インタラクティブなキットで、ハンズオンのプログラミング、ロボティクス、AIに取り組めます。',
        },
        {
          title: '職業技術教育',
          desc: 'レーザー技術プラットフォームでキャリアの基盤を築き、変化する雇用市場に対応できるスキルを伸ばして機会を広げます。',
        },
      ],
    },
    solutions: {
      title: '建築模型は幅広い分野で活用されています',
      items: [
        { title: 'K12学校／学区' },
        { title: '研修機関' },
        { title: '研究ラボ＆専門コース' },
        { title: 'メイカースペース' },
        { title: '建築系図書館／博物館' },
        { title: '創造的カリキュラム' },
      ],
    },
    bannerLeft: {
      title: 'AI教育を現場へ',
      subtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
    },
    products: {
      tabs: [
        {
          title: 'レーザー機器',
          title1: 'ものづくりの強い味方 - レーザーカッター',
          description:
            'Light 530と640は、厳選部品・高品質な製造工程・厳格な検査プロセスを組み合わせた高性能レーザー機です。高い安定性と精密な切断・彫刻を実現し、メイカー教育の現場で求められるレーザー創作ニーズに最適化されています。',
        },
        {
          title: 'ソフトウェア',
          title1: '描画の達人 - LightMaker',
          description:
            '学習者に、安全性・速度・スマート機能と、市場でも革新的な設計体験を提供します。LightMakerはAI、PS、CorelDRAW、AutoCAD、Solidworksなど多様なデザインソフトに対応し、JPG、DXF、AI、DST、PNG、BMP、TIF、SVGなど高品質データのアップロードをサポートします。',
        },
        {
          title: 'コース',
          title1: '多様な学び - メイカー教育カリキュラム',
          description:
            '一人ひとりの子どもは唯一無二。だからこそ、私たちのカリキュラムは柔軟で多様です。学習者の興味と可能性を引き出すことを目的に、テクノロジーの基礎知識、創造的思考のトレーニング、プロジェクト実践、科学実験などを幅広く扱います。',
        },
      ],
    },
    learning: {
      title: '授業でZhongze Educationのレーザーカッターをどう活用する?',
      teacher: {
        title: '教師',
        lines: [
          '授業用教具と教材の付属品を制作',
          'レーザーカッターは、教師が教具や授業用の付属品を高効率で作成するのを支援し、より新しい授業モデルの創出にもつながります。',
        ],
      },
      student: {
        title: '生徒',
        lines: [
          '実践スキルを育成',
          '授業では、レーザーカッターがデザイン、工学、テクノロジーなど分野横断的な学習を支え、生徒の頭の中のアイデアを形にする手助けをします。',
        ],
      },
    },
    carousel: {
      items: [
        { alt: '建築模型制作シーン1' },
        { alt: '建築模型制作シーン2' },
        { alt: '建築模型制作シーン3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: '建築模型 - 中等職業',
    },
    intro: {
      title: 'レーザーカッターは建築模型制作にどう活用できる？',
      desc: '建築模型制作や玩具業界の模型制作において、最小部品までレーザー切断・彫刻が可能です。繊維、プラスチック、木材、化粧板、MDF、PMMA、段ボール、紙、フォーム、発泡ポリスチレン、フィルム、アクリルなどを、素早く高精度にレーザー切断できます。',
      imageAlt: '建築模型制作におけるレーザーカッター',
    },
    scenesFeatured: {
      title: '建築模型制作を革新する力',
      desc: '精密なミニチュア試作と高品質な建築模型づくりを支援し、アイデアの設計図を美しく形にします。',
    },
    scenes: {
      items: [
        {
          title: '高精度',
          desc: 'レーザーカッターは非常に高い精度で素材を切断でき、誤差を極めて小さく抑えられます。建築模型の各パーツ寸法を正確にし、設計図の要件にぴったり合うようにします。',
        },
        {
          title: '多様な素材',
          desc: '木材の自然な質感、アクリルの透明感と光沢、紙の軽さと加工性など、レーザー切断・彫刻によってそれぞれの魅力を引き出せます。',
        },
        {
          title: '複雑形状への対応力',
          desc: '建築模型でよく見られる複雑な幾何形状や精細なディテールも、レーザー切断なら曲線や異形構造などを含めて容易に実現でき、制作の創造性を大きく広げます。',
        },
      ],
    },
    solutions: {
      title: '建築模型は多様な分野で活用されています',
      items: [
        { title: '教育・学術研究' },
        { title: '模型制作・玩具産業' },
        { title: '装飾要素・建築の特徴表現' },
        { title: '不動産・都市計画' },
        { title: '建築装飾・内装' },
      ],
    },
    bannerLeft: {
      title: 'AI教育を現場へ',
      subtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
    },
    products: {
      tabs: [
        {
          title: '適切な機器',
          title1: '適切な機器を選ぶ',
          description:
            'レーザー機器は、生徒のアイデアを素早く実物へと変換します。模型制作、デザイン、アート制作など幅広い創作をスムーズに実現。簡単な手作業から複雑な機械設計まで、レーザーカッター／彫刻機が精密に加工し、生徒の実践的な学びと成長を支えます。',
        },
        {
          title: '自分でデザイン',
          title1: '自分でデザイン',
          description:
            '直感的にデザインを修正し、最終結果をプレビューできます。テキスト、ロゴ、画像、写真を使って作品を最適化し、さまざまな素材でデザインの細部を切り出し／再現可能。建築模型も素早く装飾できます。',
        },
        {
          title: '活用シーン',
          title1: '学生のスキルを伸ばす',
          description:
            'ポータブルレーザーマーカーは、建築模型のマーキングや細部の彫刻に最適です。操作は簡単で持ち運びもしやすく、建築教育に欠かせないツールです。',
        },
      ],
    },
    learning: {
      title: '学際的な授業カリキュラム',
      groups: [
        {
          title: 'ミニチュア模型',
          lines: [
            '高精度で繊細、ミニチュア制作のニーズに対応',
            'さまざまな素材でレーザー彫刻／切断のディテールを美しく表現し、煩雑な工程を省いて効率よく制作し、手作業による誤差も減らせます。',
          ],
        },
        {
          title: 'インテリアデザイン',
          lines: [
            'デザインの細部まで一度で仕上げられます。内蔵カメラで位置やサイズを簡単にプレビューでき、見たままに出力。切断／彫刻を効率よく実行し、材料ロスも抑えます。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '建築模型制作シーン1' },
        { alt: '建築模型制作シーン2' },
        { alt: '建築模型制作シーン3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'アート＆クラフト - 大学',
    },
    intro: {
      title: 'レーザー機器でアート作品・工芸品を加工する方法',
      desc: 'この機器は、学生のアイデアを実物へ変えるためのプラットフォームを提供し、革新的な思考と創造力を引き出します。レーザー切り絵やスタンプなど、さまざまな独自の模型・作品をデザインできます。',
      imageAlt: 'アート＆クラフト加工におけるレーザー機器',
    },
    scenesFeatured: {
      title: '技術スキルの育成',
      desc: 'レーザー切断・彫刻機の操作を通じて、材料科学や加工技術の知識を深め、実践力と問題解決力を高めます。',
    },
    scenes: {
      items: [
        {
          title: '創造的思考の喚起',
          desc: 'レーザー切断・彫刻機を使って、模型や作品制作などのアイデアを形にし、創造力を伸ばせます。',
        },
        {
          title: '学際的な融合',
          desc: 'レーザー加工は物理、化学、材料科学、コンピュータサイエンスなど複数分野の知識に関わります。大学教育では分野横断の学びを促し、総合的な素養を育てます。',
        },
        {
          title: '実践的な教育プロジェクト',
          desc: '工学トレーニング、アートデザイン、文化・クリエイティブなどの実践授業で活用できます。例えば、建築模型、機械部品、芸術彫刻などを制作し、理論と実践を結び付けられます。',
        },
      ],
    },
    solutions: {
      title: '大学における工芸制作での活用',
      items: [
        { title: 'カスタム小売商品' },
        { title: 'ギフトのパーソナライズ' },
        { title: '季節キャンペーン' },
        { title: 'ジュエリー・アクセサリー' },
        { title: 'パーソナライズ衣料' },
      ],
    },
    bannerLeft: {
      title: 'AI教育を現場へ',
      subtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
    },
    products: {
      tabs: [
        {
          title: '適切な機器',
          title1: '適切な機器を選ぶ',
          description:
            '適切なレーザー切断・彫刻機器を選ぶことで、大学は先進的な実践教育ツールを学生に提供し、創造力を引き出しながら授業の品質と効率を高められます。',
        },
        {
          title: '自分でデザイン',
          title1: '自分でデザイン',
          description:
            '直感的にデザインを修正し、最終結果をプレビューできます。テキスト、ロゴ、画像、写真を使って作品を最適化し、さまざまな素材でデザインの細部を彫刻・再現できます。レーザー彫刻機は操作が簡単で、作品を素早く装飾できます。',
        },
        {
          title: 'アート＆デザイン',
          title1: 'アート＆デザイン専攻の授業',
          description:
            'アートデザイン、工業デザインなどの専攻では、レーザー切断・彫刻機が授業課題や卒業制作で広く活用されています。学生はアイデアを素早く実物へ落とし込み、プロトタイプ開発力を鍛えられます。',
        },
      ],
    },
    learning: {
      title: 'レーザーを学校へ',
      groups: [
        {
          title: '高精度・高効率で、時間と手間を削減',
          lines: [
            'Zhongzeのレーザーカッターはカメラプレビューに対応し、正確な位置合わせで材料を無駄にせず、初心者でも簡単に始められます。',
            '操作はスムーズで簡単。素材を置くだけでクリエイティブにデザインでき、見たままに出力できます。',
            '精密に制作し、素材を最大限に活かして、時間・労力・材料を節約します。',
          ],
        },
        {
          title: '高出力で、さまざまな素材に対応',
          lines: [
            '高出力CO₂レーザーを搭載し、彫刻も切断もこれ一台。',
            'アクリル、木材、竹など多様な素材を簡単に切断・彫刻でき、手作り愛好家にやさしい制作フローで、創作をより簡単かつ効率的にします。',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'アート＆クラフト制作シーン1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: '文化・クリエイティブデザイン - 高等職業',
    },
    intro: {
      title: '文化・クリエイティブデザインにおけるレーザー機器',
      desc: '高等職業学校の文化・クリエイティブデザイン専攻では、レーザー切断・彫刻機器などの先進設備を備えることが一般的で、学生の段階に応じた実践学習ニーズを満たします。',
      imageAlt: '文化・クリエイティブデザインにおけるレーザー機器',
    },
    scenesFeatured: {
      title: '創造性と品質の無限の可能性を開く',
      desc: '優れた性能と高精度な切断能力により、クリエイティブデザイナーにとって欠かせない心強いツールとなります。',
    },
    scenes: {
      items: [
        {
          title: '高精度切断で、デザインの細部まで再現',
          desc: '複雑で繊細な模様や独特な造形も、レーザーカッターなら忠実に再現できます。最終製品のあらゆるディテールを正確に表現できます。',
        },
        {
          title: '多様な素材加工',
          desc: '木材、アクリル、革、金属など幅広い素材に対応し、クリエイティブ製品のデザインに豊富な素材選択肢を提供します。',
        },
        {
          title: 'スマート操作で、制作プロセスを簡素化',
          desc: '学生はデザインした図案をPCに入力するだけで、レーザーカッターが自動認識して高精度に切断します。専門スキルへの依存を下げつつ、生産プロセスの安定性と信頼性を高めます。',
        },
      ],
    },
    solutions: {
      title: '優れたデザインを生活へ',
      items: [
        { title: '文化テーマのアートパネル' },
        { title: 'クリエイティブ照明デザイン' },
        { title: 'インテリア小物・アクセサリー' },
        { title: 'ペン立て・文具収納ボックス' },
        { title: '民族テイストのアクセサリー' },
        { title: '旅行の記念品' },
      ],
    },
    bannerLeft: {
      title: 'AI教育を現場へ',
      subtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
    },
    learning: {
      title: '高等職業の文化・クリエイティブデザインにおける制作ツール',
      groups: [
        {
          title: 'パーソナライズ',
          lines: [
            '写真、名前、特別な模様などのパーソナライズを簡単に実現し、唯一無二で記念性の高いギフトへのニーズに応えます。',
            '例えば、木製小物、革製アクセサリー、アクリル装飾品などに指定の図案や文字を彫刻し、より個性的に仕上げられます。',
          ],
        },
        {
          title: '派生グッズ制作',
          lines: [
            '博物館のクリエイティブ記念品から映画・アニメの派生商品まで、レーザー切断・彫刻機で複雑なデザインを可視化し、商品化しやすくします。',
            '名所旧跡、ランドマーク、文化IPなどの要素を実物の製品へ落とし込めます。例えば、普通の木板を独自の模様・形状の装飾品に切り出したり、紙を精緻なアート作品として彫刻したりできます。',
          ],
        },
        {
          title: 'DIY制作',
          lines: [
            'レーザー機器はハンドメイド愛好家のDIY制作をさらに高い水準へ引き上げます。小さな工芸品から個性的なインテリア装飾まで、レーザー技術で素早く実現できます。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '文化・クリエイティブデザインのシーン1' },
        { alt: '文化・クリエイティブデザインのシーン2' },
        { alt: '文化・クリエイティブデザインのシーン3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: '教育協力',
    },
    advantages: {
      title: '協力の強み',
      items: [
        {
          title: '経験豊富な研究開発チーム',
          desc: 'Zhongzeは、エンジニアとSTEM教育者で構成された専門チームを擁し、高い教育基準に適合し学生を惹きつける革新的な製品を継続的に開発しています。',
        },
        {
          title: 'AI＋教育のデジタルインテリジェンス化',
          desc: 'Zhongze Educationスマートプラットフォーム：パーソナライズ学習、スマートツール、インタラクティブ体験。コース管理、進捗追跡、課題提出、機器監視とデータ分析を支援し、クラウド資源も豊富で授業をより効率化します。',
        },
        {
          title: '豊富なキットとカリキュラム体系',
          desc: 'レーザー切断、スマートホーム、スマート交通など、初級から上級までのコースを提供し、年齢に応じた学習ニーズに対応します。',
        },
      ],
    },
    modes: {
      title: '協力モデル',
      carouselAlts: ['教育協力シーン', '教育協力授業', '教育協力実践'],
      items: [
        {
          title: 'カリキュラム導入',
          desc: '協力機関は私たちのカリキュラム体系を直接導入し、授業品質を迅速に向上できます。',
        },
        {
          title: 'キット',
          desc: 'キットは3〜16歳の子ども向けに設計され、安全で扱いやすい実験教材を通じて、科学・技術・工学・芸術・数学（STEAM）への興味を引き出します。',
        },
        {
          title: '製品協力',
          desc: '協力機関はレーザーカッターなどの教育向け製品を導入し、授業や学生の実習に活用できます。',
        },
        {
          title: '共同開発',
          desc: '協力機関によるカリキュラム・製品の共同開発への参加を歓迎し、ともに教育イノベーションを推進します。',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'AI教育を現場へ',
        'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'ダウンロードセンター',
      sectionTitle: 'ソフトウェアダウンロード',
      downloadButtonText: 'クライアントをダウンロード',
      softwareList: [
        { name: 'LightMaker App' },
        { name: 'Good-Laser LightMaker' },
        { name: 'Zhongze Education 学習プラットフォーム App' },
        { name: 'Zhongze Education 学習プラットフォーム' },
      ],
    },
    afterSales: {
      bannerTitle: 'アフターサービス',
      serviceTitle: 'ARスマートサービス',
      serviceItems: [
        {
          title: '遠隔診断',
          desc: 'AR遠隔ガイダンス：技術サポートチームが機器状態をリアルタイムで確認し、迅速に故障を診断して的確な解決提案を行います。',
        },
        {
          title: 'バーチャル修理',
          desc: 'AR操作デモ：修理手順をバーチャル表示し、直感的で分かりやすく、方法をスムーズに習得できます。',
        },
        {
          title: 'スマートチュートリアル',
          desc: 'ARインタラクティブ学習：機器上で操作ガイドを直接確認でき、効率的で便利です。',
        },
        {
          title: '迅速対応',
          desc: 'AR即時サポート：迅速に対応し待ち時間を減らし、より効率的に問題を解決します。',
        },
      ],
      videosTitle: '操作動画',
      playButtonText: '動画を再生',
      videos: [
        { title: '開梱動画' },
        { title: '機器通信の接続方法' },
        { title: 'Light 530 使用チュートリアル' },
        { title: '開梱・設置チュートリアル' },
        { title: 'ソフトの基本操作' },
        { title: 'よくある故障の切り分け' },
      ],
      manualsTitle: '取扱説明書',
      viewPdfButtonText: 'PDFを見る',
      manuals: [
        { title: 'Light 530 取扱説明書' },
        { title: 'Light 640 取扱説明書' },
        { title: 'Blue 530 ユーザーマニュアル' },
        { title: 'M20 メンテナンスガイド' },
        { title: 'レーザー切断安全マニュアル' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: '3つのキットシリーズ',
      bannerDesc:
        'キットはパーソナライズ学習を支援し、年齢や学習ニーズに応じて学べます。さらに教師には豊富な授業リソースとツールを提供し、より効果的な指導を支援します。',
      sections: {
        educationTitle: '教育キット',
        educationDesc: '創造的思考と創造力を育む',
        creativityTitle: 'アイデアで駆動し、ものづくりの未来へ',
        projectsTitle: '多様な教育プロジェクト',
      },
      kitsTabs: [
        {
          name: 'レーザー切断入門キット',
          title: 'レーザー切断入門キット\n（木板消耗材付き）',
          desc: 'レーザー切断STEAMコースは、多重知能理論、STEAM教育理念、プロジェクト型学習理論に基づき設計。年齢に応じて、創造力、批判的思考、問題解決力、コミュニケーションとチームワークを育てます。',
        },
        {
          name: 'ワクワク科学ボックス',
          title: 'ワクワク科学ボックス\n（木板＋マイクロ回路キットパック付き）',
          desc: '「義務教育科学カリキュラム基準（2022年版）」に準拠し、科学概念、科学的思考、探究実践、態度と責任の4観点からコア・コンピテンシーを育成します。各授業で1つの科学作品を完成し、伝統技能、技術工学と社会などの核心概念をカバー。科学者のように考えるよう導き、探究力を高め、科学的思考を構築します。',
        },
        {
          name: 'AIプログラミングキット',
          title: 'AIプログラミングキット',
          desc: '未来技術を探究する第一歩はAIプログラミングキットから。スマート農場、スマートホーム、スマート交通、スマート工場キットで、農業テックの理解、現代生活の体験、交通効率の探究、スマート製造の理解へ。ハンズオンで創造的思考と問題解決力を育て、スマートな世界に備えます。',
        },
      ],
      creativityItems: [
        {
          title: '実践力を強化',
          desc: 'これらのキットはSTEMA（科学・技術・工学・アート・数学）教育を統合し、ハンズオンとプロジェクト実践を通じて、実践力と問題解決力を総合的に高めます。',
        },
        {
          title: '創造的思考を育成',
          desc: '創造的な設計や実験を促し、創造的思考と創造力を育てます。チームプロジェクトでコミュニケーションと協働力も高めます。',
        },
        {
          title: '教師の授業支援',
          desc: '教師向けの豊富な授業リソースとツールを提供し、授業運営と指導をより効果的に支援します。',
        },
      ],
      projectItems: [
        { title: '科学' },
        { title: '技術' },
        { title: 'プログラミング' },
        { title: 'アート' },
      ],
      bottomBannerText:
        'コースはハンズオンとプロジェクト実践を通じて実践力を高め、現実の課題解決につなげます。創造的思考と創造力を育て、革新的な設計や実験を促進。チームプロジェクトで協働を学び、コミュニケーション力を向上。最新技術とツールに触れ、将来の社会ニーズに適応する力を養います。',
    },
    courses: {
      bannerTitle: 'コース体系',
      bannerDesc:
        '年齢に合わせて設計された体系的なSTEAMコース。科学・技術・工学・アート・数学を統合し、未来のイノベーターを育てます。',
      bannerAlt: 'コース体系',
      bottomBannerAlt: 'コース体系（コース紹介）',
      sections: {
        kitsTitle: 'コースキット',
        kitsDesc: 'ハードとソフトの最適な組み合わせ',
        seriesTitle: '厳選コースシリーズ',
      },
      courseTabs: [
        {
          name: '3〜6歳',
          title: '科学探究体系 - 幼児（全6回）',
          desc: '身近な現象を題材に科学教材で探究を深め、物事の仕組みや原理を理解します。',
        },
        {
          name: '6〜12歳',
          title: 'STEAMメイカー体系 - 児童・青少年（全3回）',
          desc: '自分のアイデアを発揮し、機器を活用してハンズオンで制作し、発想を作品へと形にします。',
        },
        {
          name: '8〜13歳',
          title: 'レーザー切断コース体系（全3回）',
          desc: '機器を使って構造部品を切り出し、立体構造を組み立てて仕上げを行います。プログラミング：条件判断のロジックと原理を理解します。',
        },
        {
          name: '6〜15歳',
          title: 'AIコース体系（全4回）',
          desc: '機器ツールで作品の外観をデザインし、プログラミングで作品をスマートかつシンプルにし、生活の課題解決につなげます。プログラミング：条件判断のロジックと原理を理解し、Arduinoの文法も学びます。',
        },
      ],
      introItems: [
        {
          title: '実践性が高い',
          desc: '実践重視の設計で、レーザーカッターなどの機器を実際に操作し、理論を実技へ落とし込みます。',
        },
        {
          title: '創造的思考の育成',
          desc: '創造的な設計と制作を促し、創造的思考と問題解決力を育てます。',
        },
        {
          title: 'プロジェクト駆動学習',
          desc: 'プロジェクト駆動の学習で、具体的な課題を完成させながら実践の中で知識を身につけます。',
        },
        {
          title: '先端技術の探究',
          desc: 'プロジェクト課題の遂行を通じて、実践的に学びながら知識を定着させます。',
        },
        {
          title: '体系的な指導',
          desc: '初級から中級へ段階的に深め、レーザー切断技術を体系的に学び、確かな知識体系を構築します。',
        },
        {
          title: '楽しさと挑戦を両立',
          desc: '楽しさとチャレンジを両立した設計で、学習意欲と探究心を引き出します。',
        },
      ],
      courseListRow1: [{ name: 'スマート農場' }, { name: 'スマートホーム' }],
      courseListRow2: [{ name: 'スマート交通' }, { name: 'スマート工場' }],
      bottomBannerText:
        '実践操作、創造的思考、学際的な融合を特長とし、プロジェクト駆動学習で先端技術を身につけます。体系的な指導、安全教育、パーソナライズ学習を組み合わせ、実践力、チームワーク、問題解決力を育成。成果発表を促し、達成感を高めます。',
    },
    kitsAccessories: {
      bannerTitle: 'キットアクセサリー',
      accessories: [
        { name: 'RGB LEDテープ' },
        { name: 'DS1307 RTCモジュール' },
        { name: 'DHT11 温湿度センサー' },
        { name: '人体検知センサー' },
        { name: 'LED照明モジュール' },
        { name: 'ファンモジュール' },
        { name: 'フォトインタラプタ（スロット型）' },
        { name: 'ボタンモジュール' },
        { name: 'コントロールボード（掌控板）' },
        { name: '拡張ボード' },
        { name: '雨滴センサー' },
        { name: 'TTモーター（変換基板付き）' },
        { name: '赤外線センサーモジュール' },
        { name: '赤外線リモコン' },
        { name: 'ガスセンサー' },
        { name: '4桁7セグ表示モジュール' },
        { name: 'マトリクスキーパッド' },
        { name: '光センサー' },
        { name: '信号機モジュール' },
        { name: 'ブザー' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'スマート卓上型レーザー切断・彫刻機',
      sections: {
        advantages: '私たちの強み',
        aiTitle: 'AI教育を現場へ',
        aiSubtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
        carouselTitle: '光で彫刻する、無限の可能性',
        specsTitle: '製品仕様',
      },
      bannerFeatures: [
        'ポイント撮影 / トレース / 安全保護',
        'STEAM教育とメイカー向けに開発',
      ],
      softwareSection: {
        title: '簡単操作で高機能なレーザー切断システム',
        items: [
          '素材に合わせて、切断・深彫り・浅彫り・スキャンなどの加工パラメータを設定できます。',
          '豊富な素材データで、デザイン効率を向上します。',
          'カメラはポイント撮影とデザイン補助に対応し、アイデアを現実にします。',
        ],
      },
      advantages: [
        {
          tagTitle: '高品質・高精度レーザー',
          desc: '例：輸入CO₂レーザーチューブ（波長10640nm）により、50Wの連続レーザー出力を提供。最大切断厚みは15mm（アクリル）。作業速度は最大1000mm/s、繰り返し位置決め精度は0.025mm。高精度を確保し、精緻な創作物を素早く正確に切断・彫刻できます。',
        },
        {
          tagTitle: '一体型・三重排気フィルターシステム',
          desc: 'フィルター、活性炭、UVオゾン層を組み合わせた多段階の排気フィルターを一体化設計。よりクリーンで環境に配慮しつつ、設置もコンパクト。別途フィルターボックスを購入する必要がなく、スペースも節約できます。',
        },
        {
          tagTitle: '最優先の安全保護',
          desc: 'SGSラボの最高安全テストに合格し、FDA認証のクラス1レーザー製品です。独自の安全設計と動作状態インジケーターにより、稼働状態を直感的に分かりやすく把握できます。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'レーザータイプ', value: '密封式CO₂ガラスレーザーチューブ' },
          { label: 'レーザーヘッド昇降ストローク', value: '≤25mm' },
          { label: '設置可能な素材厚み', value: '≤22mm' },
          { label: 'フォーカス方式', value: '自動フォーカス、手動フォーカス' },
          { label: '接続方式', value: 'USB接続、LAN接続、Wi‑Fi接続に対応' },
          { label: '対応OS', value: 'Windows、iOS' },
          {
            label: '対応デザインソフト',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworksなど',
          },
          {
            label: '対応ファイル形式',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVGなど',
          },
          { label: 'レーザー寿命', value: '≤9000時間' },
          {
            label: 'ソフトウェア',
            value: 'LightMaker（PC/モバイル）, LightBurn（PC）',
          },
          {
            label: '操作方法',
            value: '5インチLCDタッチスクリーン／スマホアプリ／PCソフト',
          },
          { label: '動作騒音', value: '≤60dB' },
          {
            label: '駆動方式',
            value:
              '高速ステッピングモーター＋高精度リニアガイド＋タイミングベルト',
          },
          {
            label: '安全保護',
            value:
              'インターロック（開蓋で停止）、衝突検知停止、緊急停止ボタン、安全キー、動作状態インジケーター、水温過昇アラーム',
          },
          { label: '電源', value: '230V/110VAC 50HZ/60HZ' },
          { label: '本体重量', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          { label: '冷却方式', value: '内蔵水冷システム（活性水）' },
          { label: '動作電圧', value: 'DC24V 空冷＋アルミコイル' },
          { label: 'タンク容量', value: '3.2L' },
          { label: '最大揚程', value: '5M' },
          {
            label: '水流量',
            value:
              '1000L/H または外付け専用CW3000レーザー用チラー（オプション）',
          },
        ],
        airPumpSpecs: [
          { label: '吐出量', value: '50L/min' },
          { label: '騒音', value: '≤48dB' },
          { label: '気圧', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: '定格出力', value: '62W' },
          { label: '風量', value: '280m³/H' },
          { label: '騒音', value: '≤50dB' },
          { label: '電圧', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: '水冷システム（内蔵）',
          airPumpTitle: 'エアポンプ（内蔵）',
          airPumpValueOnly: 'AC220V/110V 16W',
          exhaustTitle: '排気システム（外付け一体型）側面下方排気',
          filterTitle: 'フィルターシステム',
          filterValue: '活性炭フィルターマット＋静音ファン＋産業用活性炭ボード',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'スマート・ブルーレーザー切断＆彫刻機',
      sections: {
        advantages: '私たちの強み',
        aiTitle: 'AI教育を現場へ',
        aiSubtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
        carouselTitle: '光で刻む、無限の可能性',
        specsTitle: '製品仕様',
      },
      bannerFeatures: ['多素材に対応', 'いつでも自信を持って、手軽に制作'],
      advantages: [
        {
          tagTitle: '省スペース設計',
          desc: 'ブルーレーザー彫刻機は、スタイリッシュでモダン、コンパクト。家庭・学校・スタジオなど、さまざまな空間に置きやすい設計です。金属ボディとアクリルカバーの組み合わせにより、加工の様子をクリアに確認できます。',
        },
        {
          tagTitle: '密閉加工で安心・安全',
          desc: '本機は完全密閉式です。作業中にカバーを開けると自動で一時停止します。緊急時はスイッチひとつで直ちに停止でき、家庭や学校での使用に適しています。',
        },
        {
          tagTitle: '多素材加工（多種素材に対応）',
          desc: '独自の形状やスタイルのプロダクトを柔軟に制作できます。アタッチメントを追加することで、カップや円筒形などさまざまな形状の素材にも彫刻可能。小規模ビジネスのニーズにも最適です。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: '冷却システム',
          airPumpTitle: 'エアポンプ仕様',
          airPumpValueOnly: '—',
          exhaustTitle: '排気システム',
          filterTitle: 'フィルターシステム',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'レーザー種類', value: 'ブルーレーザー' },
          { key: 'laserPower', label: 'レーザー出力', value: '20W / 40W' },
          { key: 'maxCutThickness', label: '最大切断厚さ', value: '≤10mm' },
          {
            key: 'focusMode',
            label: 'フォーカス方式',
            value: '手動フォーカス',
          },
          { key: 'connection', label: '接続方式', value: 'USB 接続' },
          {
            key: 'os',
            label: '対応OS',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'ソフトウェア',
            value: 'LightBurn（电脑端）',
          },
          {
            key: 'laserLifetime',
            label: 'レーザー寿命',
            value: '≥10000 時間',
          },
          {
            key: 'maxMaterialThickness',
            label: '設置可能な材料厚さ',
            value: '15mm',
          },
          { key: 'noise', label: '動作騒音', value: '≤60dB' },
          { key: 'engraveSpeed', label: '彫刻速度', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: '対応デザインソフト',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks 等',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          { key: 'maxSpeed', label: '最大作業速度', value: '1000mm/s' },
          {
            key: 'power',
            label: '電源',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: '作業テーブルサイズ',
            value: '520 × 315mm',
          },
          { key: 'accuracy', label: '位置決め精度', value: '±0.01mm' },
          {
            key: 'repeatAccuracy',
            label: '繰り返し位置決め精度',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: '電源要件',
            value: 'AC 220V ±10%，50Hz',
          },
          { key: 'totalPower', label: '総消費電力', value: '300W' },
          {
            key: 'transmission',
            label: '駆動方式',
            value: '高速ステッピングモーター + 高精度リニアガイド + 同期ベルト',
          },
          {
            key: 'safety',
            label: '安全保護',
            value:
              'ロック解除／開蓋で停止、スプリングシャフトリミット、非常停止ボタン、安全キー',
          },
          { key: 'weight', label: '本体重量', value: '≈50kg' },
          {
            key: 'machineSize',
            label: '本体サイズ',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: '高精度レーザーマーキング機',
      sections: {
        advantages: '私たちの強み',
        aiTitle: 'AI教育を現場へ',
        aiSubtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
        carouselTitle: 'レーザーマーキングでアイデアをカタチに',
        specsTitle: '製品仕様',
      },
      bannerFeatures: [
        '安全設計：ダブルスイッチ制御、レーザー保護',
        '高精度・高速・高安定のマーキング性能',
      ],
      advantages: [
        {
          tagTitle: '多彩な用途シーン',
          desc: 'ジュエリー彫刻、パーソナライズ製品、部品識別など幅広い業界に対応。ジュエリーや香水ボトルから小型の工業用プレートまで、多様な用途のカスタム彫刻を実現します。',
        },
        {
          tagTitle: '教育分野での革新的活用',
          desc: 'Mark M20は産業レベルの精度を教育現場に導入し、STEAM／創造教育の「万能アシスタント」として、基礎的なマーキング技能から複雑なプロジェクト開発までの力を育みます。',
        },
        {
          tagTitle: 'コンパクトでモダン',
          desc: 'Mark M20は省スペースで静音、大きなビューポートを備え、高い耐久性ニーズにも対応。スタイリッシュな外観は安全基準に適合し、教育機関や公共の小売環境でも活躍します。',
        },
        {
          tagTitle: '数秒で精密マーキング',
          desc: 'Mark M20は最小サイズの文字でも、数秒で高精度にマーキングできます。この比類ない速度に、レーザーアプリケーションソフトLightMakerの簡素化されたワークフローと効率が加わり、生産性の大幅な向上を実現します。 ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          {
            key: 'laserType',
            label: 'レーザータイプ',
            value: 'ファイバーレーザー',
          },
          {
            key: 'laserPower',
            label: 'レーザー出力',
            value: '20W / 30W / 50W',
          },
          {
            key: 'markArea',
            label: 'マーキングエリア',
            value: '标准 110×110mm（可通过更换不同场镜扩展，如 175×175mm 等）',
          },
          { key: 'maxHeight', label: '最大作業高さ', value: '≤130mm' },
          { key: 'connection', label: '接続方式', value: 'イーサネット' },
          {
            key: 'os',
            label: '対応OS',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: '電源',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: '安全保護',
            value:
              'ロック解除／開蓋で停止、スプリングシャフトリミット、非常停止ボタン、安全キー',
          },
          { key: 'software', label: '対応ソフト', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: '駆動方式',
            value: 'マーキングヘッドの高精度電動ねじ昇降',
          },
          {
            key: 'fileFormat',
            label: '対応ファイル',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: '集光スポット径', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'スマート卓上型レーザー切断＆彫刻機',
      sections: {
        advantages: '私たちの強み',
        aiTitle: 'AI教育を現場へ',
        aiSubtitle: 'AI＋教育のデジタルインテリジェンス化で、革新の理念を融合',
        carouselTitle: 'クリエイティブな切断はここから',
        specsTitle: '製品仕様',
      },
      bannerFeatures: [
        '高速 / オープン式背面ドア / 高効率オートフォーカス',
        'オールインワンのレーザー彫刻・切断機',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: '作業エリア',
          desc: '優れた切断・彫刻品質。複数の機種とレーザー出力構成で、さまざまな用途のニーズに対応します。\nレーザー種類：DC CO2\nレーザー出力：60W-130W\nLight640（600*400mm）\nLight960（900*600mm）\nLight1390（1300*900mm）\nLight1610（1600*1000mm）',
        },
        {
          tagTitle: '高効率オートフォーカス＋赤点ポインタ位置合わせ',
          desc: 'オートフォーカス機能により、切断・彫刻前に素早く正確にフォーカスと位置合わせが行えます。赤点ポインタのビームと組み合わせることで、作業位置をリアルタイムに確認可能。切断・彫刻の時間を大幅に短縮し、より良い仕上がりを実現します。',
        },
        {
          tagTitle: 'オープン式背面ドア設計',
          desc: '背面ドアをオープンにできる設計で、長さに制限のない材料の切断・彫刻が可能です。600mm×∞の板材にも対応し、作業をより便利に、制約をより少なくします。',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: '優れた切断・彫刻品質',
            desc: '高精度レーザー切断プラットフォームを搭載。木材やアクリルなどの加工で、企業レベルの加工基準と効率を実現し、レーザー工芸品の量産を支援。生産性とブランド価値の飛躍的向上に貢献します。',
          },
          {
            tagTitle: '高品質レーザーチューブと精密部品を搭載',
            desc: '多彩な製品ラインで、ニーズに応じてレーザー種類と加工強度を選択可能。さまざまな生産要件に対応し、木材・ガラス・アクリルなどの素材や工法に、より幅広い適用性を提供します。',
          },
          {
            tagTitle: '厳格な品質テストで品質保証',
            desc: '出荷前に生産ラインで厳格にテストを実施。精密な光路制御と5回を超える切断・彫刻テストにより、安定した一貫出力を実現するトップクラスのCO2レーザーチューブを保証します。優れた出力安定性と微細なレーザースポットにより、均一な彫刻から複雑なディテールまで表現可能です。',
          },
        ],
        light1390: [
          {
            tagTitle: '優れた切断・彫刻品質',
            desc: '高精度レーザー切断プラットフォームを搭載。木材やアクリルなどの加工で、企業レベルの加工基準と効率を実現し、レーザー工芸品の量産を支援。生産性とブランド価値の飛躍的向上に貢献します。',
          },
          {
            tagTitle: '高品質レーザーチューブと精密部品を搭載',
            desc: '多彩な製品ラインで、ニーズに応じてレーザー種類と加工強度を選択可能。さまざまな生産要件に対応し、木材・ガラス・アクリルなどの素材や工法に、より幅広い適用性を提供します。',
          },
          {
            tagTitle: '厳格な品質テストで品質保証',
            desc: '出荷前に生産ラインで厳格にテストを実施。精密な光路制御と5回を超える切断・彫刻テストにより、安定した一貫出力を実現するトップクラスのCO2レーザーチューブを保証します。優れた出力安定性と微細なレーザースポットにより、均一な彫刻から複雑なディテールまで表現可能です。',
          },
        ],
        light1610: [
          {
            tagTitle: '包括的で先進的な安全機能',
            desc: '1. 非常停止\n2. 警告灯\n3. 防水スイッチ\n4. アース線\n5. 内蔵熱検知アラームが機器の異常時に自動作動\n6. カバー施錠保護\n7. 強化ガラス製の耐久保護窓',
          },
          {
            tagTitle: '長寿命で優れた品質',
            desc: '1. 単品制作から大規模生産まで幅広く対応。\n2. 作業エリアは600 x 400MMから1600 x 1000MMまで選択可能。\n3. 比類ない彫刻速度。\n4. 業界エキスパートによる設計。\n5. パーソナライズ、教育、産業用途に最適です。',
          },
          {
            tagTitle: 'スマート監視で生産を最適化',
            desc: '高価な機器コンポーネント（軸、レーザーヘッド、光学部品、レンズ）を、ほこりや汚れによる侵食から守るために設計されています。高頻度の使用でも、長年にわたり故障のない運用を支えます。',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Light 640でできること',
          items: [
            {
              title: 'Light 640 - プロジェクト 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - プロジェクト 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - プロジェクト 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - プロジェクト 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - プロジェクト 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - プロジェクト 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - プロジェクト 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - プロジェクト 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Light 960でできること',
          items: [
            {
              title: 'Light 960 - プロジェクト 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - プロジェクト 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - プロジェクト 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - プロジェクト 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - プロジェクト 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - プロジェクト 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - プロジェクト 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - プロジェクト 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Light 1390でできること',
          items: [
            {
              title: 'Light 1390 - プロジェクト 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - プロジェクト 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Light 1610でできること',
          items: [
            {
              title: 'Light 1610 - プロジェクト 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 7',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - プロジェクト 8',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: '冷却システム',

          exhaustTitle: '排気システム',
        },
        left: [
          { key: 'model', label: '機種', value: 'Light 640' },
          { key: 'workArea', label: '加工エリア', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'レーザー種類',
            value: '密閉式 CO₂ ガラスレーザーチューブ',
          },
          {
            key: 'laserPower',
            label: 'レーザー出力',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Z軸高さ',
            value: '135mm（5.3 英寸）',
          },
          {
            key: 'tableSize',
            label: 'テーブルサイズ',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: '最大材料サイズ（前後ドア閉）',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: '最大材料サイズ（背面ドア開）',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: '本体サイズ（幅 × 奥行 × 高さ）',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: '本体重量',
            value: '300kg（660 磅）',
          },
          {
            key: 'maxSpeed',
            label: '最大作業速度',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: '位置決め精度',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'フォーカスモード',
            value: 'オートフォーカス / 手動フォーカス',
          },
          {
            key: 'resume',
            label: '停電後の継続彫刻',
            value: '対応',
          },
          {
            key: 'transmission',
            label: '駆動方式',
            value: '高速ステッピングモーター + 高精度クローズドループモーター',
          },
          {
            key: 'connection',
            label: '通信方式',
            value: 'LAN / USB / Wi-Fi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'ソフトウェア',
            value: 'Good-Laser LightMaker（LightBurn対応）',
          },
          {
            key: 'process',
            label: '加工プロセス',
            value: '線画、切断、深彫り、浅彫り',
          },
          {
            key: 'fileFormats',
            label: '対応ファイル形式',
            value:
              'ビットマップ：JPG / PNG / BMP；ベクター：LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: '周波数',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: '相数',
            value: '単相',
          },
          {
            key: 'current',
            label: 'フルロード電流',
            value: '6A',
          },
          {
            key: 'voltage',
            label: '電圧',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: '総消費電力',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: '対応材料',
            value:
              '木材、アクリル、革、布、プラスチック、段ボール、ゴム、二色板、大理石、ガラス、アルマイト処理アルミおよびその他の非金属材料',
          },
          {
            key: 'safety',
            label: '安全規格',
            value:
              'EUのCE安全規格に適合。作業室の開蓋保護、冷却保護システム、温度制御の自動アラーム、漏電回路保護、非常停止保護、光路システム、強化ガラス観察システム、稼働状態インジケータなどを備えます。',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: '冷却方式',
            value: '水冷',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: '排気口径',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: '密閉式 CO₂ ガラスレーザーチューブ',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg（902 磅）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'オートフォーカス / 手動フォーカス',
          resume: '対応',
          transmission:
            '高速ステッピングモーター + 高精度クローズドループモーター',
          connection: 'LAN / USB / Wi-Fi',
          software: 'Good-Laser LightMaker（LightBurn対応）',
          process: '線画、切断、深彫り、浅彫り',
          fileFormats:
            'ビットマップ：JPG / PNG / BMP；ベクター：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '単相',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、アクリル、革、布、プラスチック、段ボール、ゴム、二色板、大理石、ガラス、アルマイト処理アルミおよびその他の非金属材料',
          safety:
            'EUのCE安全規格に適合。作業室の開蓋保護、水冷保護システム、温度制御の自動アラーム、漏電回路保護、非常停止保護、光路システム、強化ガラス観察システム、稼働状態インジケータなどを備えます。',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: '密閉式 CO₂ ガラスレーザーチューブ',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg（1100 磅）',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'オートフォーカス / 手動フォーカス',
          resume: '対応',
          transmission:
            '高速ステッピングモーター + 高精度クローズドループモーター',
          connection: 'LAN / USB / Wi-Fi',
          software: 'Good-Laser LightMaker（LightBurn対応）',
          process: '線画、切断、深彫り、浅彫り',
          fileFormats:
            'ビットマップ：JPG / PNG / BMP；ベクター：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '単相',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、アクリル、革、布、プラスチック、段ボール、ゴム、二色板、大理石、ガラス、アルマイト処理アルミおよびその他の非金属材料',
          safety:
            'EUのCE安全規格に適合。作業室の開蓋保護、水冷保護システム、温度制御の自動アラーム、漏電回路保護、非常停止保護、光路システム、強化ガラス観察システム、稼働状態インジケータなどを備えます。',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: '密閉式 CO₂ ガラスレーザーチューブ',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg（1298 磅）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'オートフォーカス / 手動フォーカス',
          resume: '対応',
          transmission:
            '高速ステッピングモーター + 高精度クローズドループモーター',
          connection: 'LAN / USB / Wi-Fi',
          software: 'Good-Laser LightMaker（LightBurn対応）',
          process: '線画、切断、深彫り、浅彫り',
          fileFormats:
            'ビットマップ：JPG / PNG / BMP；ベクター：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '単相',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、アクリル、革、布、プラスチック、段ボール、ゴム、二色板、大理石、ガラス、アルマイト処理アルミおよびその他の非金属材料',
          safety:
            'EUのCE安全規格に完全適合。開蓋保護、水冷保護、温度アラーム、漏電保護、非常停止、レーザー閉ループシステムを備えます。',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'メールアドレス',
      button: '登録',
    },
    social: {
      tiktok: 'Douyin',
      weibo: 'WeChatチャンネル',
      wechat: 'WeChat',
      redbook: 'RED（小紅書）',
    },
    companyDesc:
      '3〜16歳の子ども・青少年の科学技術創造力教育に注力し、メイカー教育スペースを開設。教育向けプロダクトとカリキュラムを自社開発し、学習用デザインソフト、レーザー彫刻、プログラミングなどの領域を中心にコンテンツを展開しています。',
    navColumns: [
      {
        title: '製品',
        items: [
          { label: '機器', to: '/product/light530' },
          { label: 'キット', to: '/product/kits' },
          { label: 'コース', to: '/product/courses' },
        ],
      },
      {
        title: 'ソフトウェア',
        items: [
          {
            label: 'Zhongze Education クラウドプラットフォーム',
            to: '/software/cloud-platform',
          },
          {
            label: 'Zhongze Education 学習プラットフォーム',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: '教育サービス',
        items: [
          { label: 'AI教育ソリューション', to: '/edu-services' },
          { label: 'メイカー教育—小中学校', to: '/edu-services/maker-k12' },
          {
            label: '建築模型—職業高校',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: '文化・クリエイティブデザイン—高等職業',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'アート＆クラフト—大学',
            to: '/edu-services/arts-university',
          },
          { label: 'メイカースペース', to: '/edu-services' },
        ],
      },
      {
        title: 'サポート',
        items: [
          { label: 'ダウンロードセンター', to: '/support/download' },
          { label: 'アフターサービス', to: '/support/after-sales' },
        ],
      },
      {
        title: '教育協力',
        items: [{ label: '教育協力', to: '/edu-services/cooperation' }],
      },
      {
        title: '私たちについて',
        items: [
          { label: '私たちについて', to: '/about' },
          { label: 'ニュース', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: '販売ホットライン：18379276683',
      email: 'メール：sam@zz-steam.com',
      address: '住所：深圳市福田区八卦四路 華晟達ビルA棟',
    },
    qrDesc: 'もっと見る',
  },

  globalContactForm: {
    title: 'お問い合わせ',
    subtitle:
      '以下のフォームにご記入ください。できるだけ早くご連絡いたします。',
    fields: {
      name: 'お名前',
      email: 'メール',
      phone: '電話',
      company: '会社',
      message: 'メッセージ',
    },
    placeholders: {
      name: 'お名前を入力してください',
      email: 'メールアドレスを入力してください',
      phone: '電話番号を入力してください',
      company: '会社名を入力してください',
      message: 'メッセージを入力してください',
    },
    submitting: '送信中...',
    submit: '送信',
    visual: {
      title: 'ご一緒できることを楽しみにしています',
      description:
        '専門的なサービスとサポートを提供しています。ご不明点があればいつでもお問い合わせください。',
    },
    contact: {
      phone: '連絡先電話番号',
      email: '連絡先メール',
    },
    validation: {
      name: 'お名前を入力してください',
      email: 'メールアドレスを入力してください',
      emailFormat: '正しいメール形式を入力してください',
      phone: '電話番号を入力してください',
      phoneFormat: '有効な電話番号を入力してください',
      message: 'メッセージを入力してください',
    },
    success: '送信が完了しました。できるだけ早くご連絡します。',
    networkError: '送信に失敗しました。しばらくしてから再試行してください。',
  },
};
